import React, { useContext, useState, useEffect, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import {
  Button,
  ButtonGroup,
  Row,
  Col,
  Table,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Header from "../../layout/Header/Header";
import { TableHeader, Pagination, Search } from "../../DataTable";

function ReporteTraspasos() {
  const { user } = useContext(AuthContext);
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_ARTICULOS_TS = process.env.REACT_APP_URL_ARTICULOS_TS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const headersAuth = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const fmt = (d) => d.toISOString().split("T")[0];
  let hoy = new Date();
  let hace90 = new Date();
  hace90.setDate(hace90.getDate() - 90);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(fmt(hace90));
  const [selectedFechaFin, setSelectedFechaFin] = useState(fmt(hoy));
  const [areas, setAreas] = useState([]);
  const [selectedAreaSalida, setSelectedAreaSalida] = useState("");
  const [selectedAreaEntrada, setSelectedAreaEntrada] = useState("");
  const [comments, setComments] = useState([]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  //--- Pagination
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 50;

  const headers = [
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Modelo", field: "modelo", sortable: true },
    { name: "Almacen Salida", field: "areaSalida", sortable: true },
    { name: "Almacen Entrada", field: "areaEntrada", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Recibida", field: "recibida", sortable: true },
  ];

  useEffect(() => {
    axios
      .get(URL_AREAS, { headers: headersAuth })
      .then((res) => setAreas(res.data))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (!selectedFechaInicio || !selectedFechaFin) return;
    axios
      .get(`${URL_ARTICULOS_TS}/reporteFechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: headersAuth,
      })
      .then((res) => setComments(res.data))
      .catch((err) => console.log(err));
  }, [selectedFechaInicio, selectedFechaFin]);

  // Filtros (área + buscador). Las fechas vienen aplicadas del servidor.
  const matchFiltros = (a) => {
    const s = search.toLowerCase();
    const pasaBusqueda =
      !search ||
      (a.modelo || "").toLowerCase().includes(s) ||
      (a.areaSalida || "").toLowerCase().includes(s) ||
      (a.areaEntrada || "").toLowerCase().includes(s) ||
      (a.recibida || "").toLowerCase().includes(s) ||
      (a.fecha || "").toLowerCase().includes(s) ||
      a.cantidad?.toString().includes(s);
    return (
      (selectedAreaSalida === "" || selectedAreaSalida == a.idAreaSalida) &&
      (selectedAreaEntrada === "" || selectedAreaEntrada == a.idAreaEntrada) &&
      pasaBusqueda
    );
  };

  // Set completo filtrado (para exportaciones y total)
  const filtradosCompleto = comments.filter(matchFiltros);
  const totalCantidad = filtradosCompleto.reduce(
    (t, a) => t + (parseFloat(a.cantidad) || 0),
    0
  );

  const commentsData = useMemo(() => {
    let computed = comments.filter(matchFiltros);
    setTotalItems(computed.length);

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      if (sorting.field === "cantidad") {
        computed = [...computed].sort(
          (a, b) => reversed * ((parseFloat(a.cantidad) || 0) - (parseFloat(b.cantidad) || 0))
        );
      } else {
        computed = [...computed].sort(
          (a, b) =>
            reversed * String(a[sorting.field] || "").localeCompare(String(b[sorting.field] || ""))
        );
      }
    }

    return computed.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
    // eslint-disable-next-line
  }, [comments, currentPage, search, sorting, selectedAreaSalida, selectedAreaEntrada]);

  function PDF() {
    const data = filtradosCompleto.map((a) => [
      a.fecha,
      a.modelo,
      a.areaSalida,
      a.areaEntrada,
      new Intl.NumberFormat("en-US").format(a.cantidad),
      a.recibida,
    ]);

    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    try {
      doc.addImage(img2, "png", 120, 10, 30, 30);
    } catch (e) {}
    doc.text(`Reporte de Traspasos`, 20, 30);
    doc.setFontSize(12);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Fecha", "Modelo", "Almacen Salida", "Almacen Entrada", "Cantidad", "Recibida"]],
      body: data,
      headStyles: { fillColor: ["#f28029"], lineWidth: 0 },
      footStyles: { fillColor: ["#f28029"] },
      theme: "grid",
      startY: 45,
      foot: [
        ["", "", "", "Total", new Intl.NumberFormat("en-US").format(totalCantidad), ""],
      ],
      showFoot: "lastPage",
    });
    doc.save(`ReporteTraspasos.pdf`);
  }

  function excel() {
    const dataExcel = filtradosCompleto.map((a) => ({
      Fecha: a.fecha,
      Modelo: a.modelo,
      "Almacen Salida": a.areaSalida,
      "Almacen Entrada": a.areaEntrada,
      Cantidad: a.cantidad,
      Recibida: a.recibida,
    }));

    const option = {};
    option.fileName = "ReporteTraspasos";
    option.datas = [
      {
        sheetData: dataExcel,
        sheetName: "ReporteTraspasos",
        sheetFilter: ["Fecha", "Modelo", "Almacen Salida", "Almacen Entrada", "Cantidad", "Recibida"],
        sheetHeader: ["Fecha", "Modelo", "Almacen Salida", "Almacen Entrada", "Cantidad", "Recibida"],
      },
    ];
    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = filtradosCompleto.map((a) => [
      a.fecha,
      a.modelo,
      a.areaSalida,
      a.areaEntrada,
      new Intl.NumberFormat("en-US").format(a.cantidad),
      a.recibida,
    ]);

    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    try {
      doc.addImage(img2, "png", 120, 10, 30, 30);
    } catch (e) {}
    doc.text(`Reporte de Traspasos`, 20, 30);
    doc.setFontSize(12);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Fecha", "Modelo", "Almacen Salida", "Almacen Entrada", "Cantidad", "Recibida"]],
      body: data,
      headStyles: { fillColor: ["#f28029"], lineWidth: 0 },
      footStyles: { fillColor: ["#f28029"] },
      theme: "grid",
      startY: 45,
      foot: [
        ["", "", "", "Total", new Intl.NumberFormat("en-US").format(totalCantidad), ""],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte de Traspasos",
          email: mailTo,
          fileName: "ReporteTraspasos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Reporte de Traspasos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         </table>`,
        },
        { headers: headersAuth }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
        console.log(error);
      });
  }

  const areasOrdenadas = [...areas].sort((a, b) =>
    (a.name || "") > (b.name || "") ? 1 : -1
  );

  return (
    <>
      <Header />
      <br />
      {user.menu_traspasos_salida ? (
        <div className="card col-12">
          <Row>
            <Col md={8}></Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button size="sm" className="btn" color="danger" onClick={PDF}>
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button size="sm" className="btn" color="info" onClick={toggleMail}>
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button size="sm" className="btn" color="primary" onClick={excel}>
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <h3 align="center">Reporte de Traspasos</h3>

          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Reporte de Traspasos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => setMailTo(e.target.value)}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Almacen Salida</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedAreaSalida}
                onChange={(e) => {
                  setSelectedAreaSalida(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                {areasOrdenadas.map((a) => (
                  <option key={a._id} value={a._id}>
                    {a.name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Almacen Entrada</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedAreaEntrada}
                onChange={(e) => {
                  setSelectedAreaEntrada(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                {areasOrdenadas.map((a) => (
                  <option key={a._id} value={a._id}>
                    {a.name}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
          <br />

          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.length === 0 ? (
                <tr>
                  <td colSpan={6} align="center">
                    Sin resultados
                  </td>
                </tr>
              ) : (
                commentsData.map((a, i) => (
                  <tr key={i}>
                    <td>{a.fecha}</td>
                    <td>{a.modelo}</td>
                    <td>{a.areaSalida}</td>
                    <td>{a.areaEntrada}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                    <td>{a.recibida}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          <Row>
            <Col md={12} align="right">
              <h5>
                Total Cantidad:{" "}
                <strong>{new Intl.NumberFormat("en-US").format(totalCantidad)}</strong>
              </h5>
            </Col>
          </Row>

          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />
    </>
  );
}

export default ReporteTraspasos;
